export const SearchIcon = ({ className }: { className?: string }) => (
    <svg
        className={className || ''}
        width="17"
        height="18"
        viewBox="0 0 17 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M12.0616 13.1449L10.0166 11.6305C10.6557 10.8733 10.9752 9.86366 10.9752 8.79094C10.9752 6.2669 8.86632 4.18457 6.31013 4.18457C3.75394 4.18457 1.70898 6.33 1.70898 8.85404C1.70898 11.3781 3.81784 13.4604 6.37403 13.4604C7.52432 13.4604 8.54679 13.0818 9.37756 12.3877L11.5503 13.9652C11.6142 14.0283 11.742 14.0283 11.8059 14.0283C11.9337 14.0283 12.1255 13.9652 12.1894 13.839C12.3172 13.6497 12.2533 13.3342 12.0616 13.1449ZM2.66756 8.85404C2.66756 6.83481 4.32908 5.19419 6.37403 5.19419C8.41898 5.19419 10.0166 6.83481 10.0166 8.85404C10.0166 10.8733 8.35508 12.4508 6.37403 12.4508C4.39298 12.4508 2.66756 10.8102 2.66756 8.85404Z"
            fill="white"
        />
    </svg>
);
